export default __webpack_public_path__ + "static/media/supportFit.8e733514.jpeg";